export const COOLDOWN_DURATION = 2000
